import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
  Redirect,
  withRouter
} from 'react-router-dom'
import { Breadcrumb, Card } from 'antd';
import Dashboard from './dashboard';
import ChangePW from './changepw'; 
import EditableTable from './projects';
import ProjectList from './projectlist';
import LimitedList from './limitedlist';
import Limited from './limited';
import Events from './events';
import Login from './login';
import Media from './media';

import fakeAuth from './autha';

import AdminDash from '../tests/admindash';
import AdminUnits from '../tests/adminunits';

import "../App.css";
import { Layout, Button, Divider } from "antd";
import { auth } from '../firebase';
const ButtonGroup = Button.Group;


const Public = () => <h2>This page is public, no sign in required.</h2>

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    fakeAuth.isAuthenticated === true
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }} />
  )} />
)

const AuthButton = withRouter(({ history }) => (
  fakeAuth.isAuthenticated ? (
    <div>
      <Card className='header'>
        <p>Welcome!</p>
        <Divider type="vertical" />
        <Button size='large' onClick={() => {
          auth.doSignOut().then(function() {
            // Sign-out successful.
            fakeAuth.signout(() => history.push('/'))
          }).catch(function(error) {
            console.log('signout error')
          });
        }}>Sign out
      </Button>
      <Divider type="vertical" />
      <Button type='primary'  size='large' ghost><Link to='/changepw'>
            Change Password
        </Link></Button>
        <ButtonGroup size='large' className="np" >
          <Button type='primary' ><Link to='/dashboard/events'>
            Events
        </Link></Button>
          <Button type='primary' ><Link to='/dashboard/projects'>
            Projects
        </Link></Button>
        </ButtonGroup>
      </Card>
    </div>
  ) : (
      <Card className='header'>
        <p>SP Cloud - Interactive Panel CMS</p>
      </Card>
    )
))








const breadcrumbNameMap = {
  '/admin': 'Admin',
  '/changepw': 'Change Password',
  '/dashboard': 'Dashboard',
  '/dashboard/events': 'Events',
  '/dashboard/projects': 'Projects',
  '/dashboard/limited': 'Limited Units',
  '/dashboard/projects/:id': 'ff',
};
const Bread = withRouter((props) => {
  const { location } = props;
  const pathSnippets = location.pathname.split('/').filter(i => i);
  // var id = pathSnippets[2];
  var name = 'a';
  if (pathSnippets.length > 3) {
    pathSnippets.splice(2, 1)
    name = pathSnippets[2];
  }

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;

    return (
      <Breadcrumb.Item key={url}>
        <Link to={index < 2 ? url : index === 2 ? name : 'not 2!'}>
          {index < 2 ? breadcrumbNameMap[url] : index === 2 ? name : 'not 2!'}
        </Link>
      </Breadcrumb.Item>
    );
  });

  const breadcrumbItems = [(
    <Breadcrumb.Item key="home">
      <Link to="/">Home</Link>
    </Breadcrumb.Item>
  )].concat(extraBreadcrumbItems);
  return (
    <Breadcrumb>
      {breadcrumbItems}
    </Breadcrumb>

  );
});


export default function AuthExample() {
  return (
    <Router>
      <div>
        <Layout className="App">
          <div className="block">
            <AuthButton className="nq" />
          </div>
          <Card className='header-btm'>
            <Bread />
          </Card>

          <Switch>
            <Route path="/public" component={Public} />
            <PrivateRoute exact path="/" component={Dashboard} />
            <Route path="/login" component={Login} />
            <PrivateRoute exact path='/dashboard' component={Dashboard} />
            <PrivateRoute exact path='/changepw' component={ChangePW} />

            <PrivateRoute exact path='/admin' component={AdminDash} />
            <PrivateRoute exact path='/admin/units' component={AdminUnits} />


            <PrivateRoute exact path='/dashboard/limited' component={LimitedList} />
            <PrivateRoute path='/dashboard/limited/:id/:title' component={Limited} />

            <PrivateRoute exact path='/dashboard/projects' component={ProjectList} />
            <PrivateRoute path='/dashboard/projects/:id/:name' component={EditableTable} />

            <PrivateRoute exact path='/dashboard/events' component={Events} />
            <PrivateRoute path='/dashboard/events/:id/:title' component={Media} />


            <Route component={Login} />
          </Switch>


        </Layout>
      </div>
    </Router>
  )
}


// WEBPACK FOOTER //
// ./src/views/home.js